import React, { useState } from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover';
import cn from 'classnames';
import { QuestionMarkIcon, InfoIcon } from '~/svgs';

const PopOverQuestionMark = ({ content, info, showInfoIcon, iconSize, wrapperClassName }: any) => {
   const [showPopover, setShow] = useState(false);
   return (
      <Popover
         isOpen={showPopover}
         positions={['bottom']}
         padding={15}
         containerClassName="z-[999999]"
         onClickOutside={() => setShow(false)}
         content={({ position, childRect, popoverRect }) => (
            <div>
               <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                  position={position}
                  childRect={childRect}
                  popoverRect={popoverRect}
                  arrowColor="white"
                  arrowSize={10}
                  className="popover-arrow-container"
                  arrowClassName="popover-arrow">
                  <div
                     className={cn(
                        'px-4 w-96 py-2 text-xs text-gray-400 bg-white rounded-default',
                        wrapperClassName && wrapperClassName
                     )}
                     style={{ boxShadow: '0px 4px 72px rgba(0, 0, 0, 0.12)' }}>
                     {content || ''}
                     {info || ''}
                  </div>
               </ArrowContainer>
            </div>
         )}>
         <div onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
            {showInfoIcon ? (
               <InfoIcon
                  className="[&>*]:fill-grey-200"
                  width={iconSize || 15}
                  height={iconSize || 15}
               />
            ) : (
               <QuestionMarkIcon />
            )}
         </div>
      </Popover>
   );
};

export default PopOverQuestionMark;
